import React, { useContext } from 'react';
import Select from 'react-select';
import { useIntl } from 'react-intl';
import { LOCALES } from '../../constans/constans';
import English from '../../lang/en-US.json';
import French from '../../lang/fr-FR.json';
// import Portuguese from '../../lang/pt-BR.json';
import Spanish from '../../lang/es-ES.json';
import { appStore } from '../../state/app';

const LangSwitcher = () => {
  const { state, update } = useContext(appStore);
  const { app: { locales } } = state;
  const translate = useIntl();
  const selectLanguage = (selectedOption) => {
    const newLocale = selectedOption.value;
    update('app.locales', newLocale);
    localStorage.setItem('locales', newLocale);

    switch (newLocale) {
      case LOCALES.ENGLISH.value:
        update('app.messages', English);
        break;
      case LOCALES.SPANISH.value:
        update('app.messages', Spanish);
        break;
      case LOCALES.FRENCH.value:
        update('app.messages', French);
        break;
      default:
        update('app.messages', English);
        break;
    }
  };

  const options = [
    { value: LOCALES.ENGLISH.value, label: LOCALES.ENGLISH.label },
    { value: LOCALES.SPANISH.value, label: LOCALES.SPANISH.label },
    { value: LOCALES.FRENCH.value, label: LOCALES.FRENCH.label },
  ];

  const customStyles = {
    container: (styles) => ({
      ...styles,
      minWidth: '110px',

    }),
    control: (styles) => ({
      ...styles,
      color: '#4D4D4C',
      fontSize: '14px',
      fontWeight: '500',
      fontFamily: 'inherit',
      border: 'none',
      boxShadow: 'none',
      cursor: 'pointer',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (styles) => ({
      ...styles,
      color: '#4D4D4C',
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: '#4D4D4C',
    }),
    menu: (styles) => ({
      ...styles,
      boxShadow: 'none',
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      color: '#4D4D4C',
      backgroundColor: isSelected ? '#E6E6E6' : 'white',
      fontSize: '14px',
      fontWeight: '500',
      '&:hover': {
        backgroundColor: '#F2F3F7',
        borderRadius: '4px',
      },
    }),
    singleValue: (styles) => ({
      ...styles,
      color: '#4D4D4C',
      fontWeight: '500',
    }),
  };

  const selectedOption = options.find((opt) => opt.value === locales);

  return (
    <Select
      options={options}
      styles={customStyles}
      onChange={selectLanguage}
      value={selectedOption}
      components={{
        SingleValue: () => <div style={{ color: '#4D4D4C' }}>{translate.formatMessage({ id: 'language' })}</div>,
      }}
      placeholder="Language"
    />
  );
};

export default LangSwitcher;
